module.exports = __webpack_public_path__ + "img/top.b2c8305b.svg";